import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c(VRow, [_c(VCol, {
    staticClass: "pb-0 mb-3"
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.search'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "append-icon": "fal fa-search",
      "hide-details": "auto",
      "single-line": "",
      "clearable": ""
    },
    model: {
      value: _vm.searchItem,
      callback: function ($$v) {
        _vm.searchItem = $$v;
      },
      expression: "searchItem"
    }
  })], 1)], 1), _c(VDataTable, {
    attrs: {
      "items": _vm.contents,
      "headers": _vm.tblHeaders,
      "search": _vm.searchItem,
      "footer-props": _vm.tableFooterProps,
      "expanded": _vm.expanded,
      "item-key": "eui",
      "hide-default-header": ""
    },
    on: {
      "update:expanded": function ($event) {
        _vm.expanded = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function ({
        props
      }) {
        return [_c('th'), _vm._l(props.headers, function (header, key) {
          return _c('th', {
            key: key
          }, [_vm._v("\n        " + _vm._s(header.text) + "\n         \n        "), _c(VIcon, {
            staticClass: "pointer",
            attrs: {
              "color": _vm.color,
              "dark": "",
              "small": ""
            },
            on: {
              "click": function ($event) {
                return _vm.deleteColumn(key);
              }
            }
          }, [_vm._v("fal fa-trash-alt")])], 1);
        }), _c('th')];
      }
    }, {
      key: "item",
      fn: function ({
        item,
        expand,
        isExpanded
      }) {
        return [_c('tr', {
          class: item.error && item.msg ? 'pointer' : null,
          on: {
            "click": function ($event) {
              item.error && item.msg ? expand(!isExpanded) : null;
            }
          }
        }, [_c('td', [item.error === false ? _c(VIcon, {
          attrs: {
            "color": _vm.getColor('success'),
            "title": _vm.$i18n_t('Common.delete'),
            "small": ""
          }
        }, [_vm._v("\n            fal fa-check-circle\n          ")]) : _vm._e(), item.error && item.msg ? _c('span', [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "small": ""
          }
        }, [_vm._v("fal fa-angle-down")]), _vm._v("\n             \n            "), _c(VIcon, {
          attrs: {
            "color": _vm.getColor('error'),
            "title": _vm.$i18n_t('Common.delete'),
            "small": ""
          }
        }, [_vm._v("fal fa-times")])], 1) : _vm._e()], 1), _vm._l(Object.keys(_vm.filteredContent), function (col) {
          return _c('td', {
            key: col
          }, [_vm._v("\n          " + _vm._s(item[col]) + "\n        ")]);
        }), _c('td', {
          staticClass: "text-right"
        }, [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.edit'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              _vm.$emit('edit-item', item, _vm.contents.indexOf(item));
            }
          }
        }, [_vm._v("\n            fal fa-edit\n          ")]), _vm._v("\n           \n          "), _c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.delete'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              _vm.deleteRow(_vm.contents.indexOf(item));
            }
          }
        }, [_vm._v("\n            fal fa-trash-alt\n          ")])], 1)], 2)];
      }
    }, {
      key: "expanded-item",
      fn: function (props) {
        return [_c('tr', [_c('td', {
          attrs: {
            "colspan": _vm.tblHeaders.length + 2
          }
        }, [_c('div', {
          staticClass: "px-2 highlighted"
        }, [_c('p', {
          staticClass: "text-overline pt-1 mb-0"
        }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.details.statusErrorMsg')))]), _vm._v("\n            " + _vm._s(props.item.msg) + "\n          ")])])])];
      }
    }, {
      key: "no-data",
      fn: function () {
        return [_c(VAlert, {
          staticClass: "mb-1",
          attrs: {
            "value": true,
            "color": "transparent",
            "icon": "fal fa-comment-exclamation"
          }
        }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Common.SorryNothingToDisplay')) + "\n      ")])];
      },
      proxy: true
    }])
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };